module.exports = __webpack_public_path__ + "img/no_task148.55c52f23.png";